module.exports = __webpack_public_path__ + "static/img/05.63ab32f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/05.png
// module id = B/nJ
// module chunks = 1